import { Box, Button, Flex, customStyled, variant } from '@mafc/trolly';
import COLORS from 'theme/colors';
import {
  IVoucherCardVariant,
  VoucherBadgeVariant,
  VOUCHER_CARD_VARIANT,
} from './VoucherCard.constants';

export const VoucherCard = customStyled(Box)<{
  variant: IVoucherCardVariant;
  isApplied: boolean;
}>(
  ({ theme: { radii, fontSizes, space } }) => ({
    borderRadius: radii[4],
    fontSize: fontSizes[2],
    marginBottom: space[3],
    border: `1px solid ${COLORS.LIGHT_GRAY}`,
    overflow: 'hidden',
  }),
  (props: any) =>
    variant({
      variants: {
        [VOUCHER_CARD_VARIANT.ERROR]: {
          borderColor: COLORS.DARK_PINK,
          background: props.theme.colors.peach,
        },
        [VOUCHER_CARD_VARIANT.SUCCESS]: {
          background: props.theme.colors.lightGreen,
        },
        [VOUCHER_CARD_VARIANT.DISABLED]: {
          background: props.theme.colors.GRAY_100,
        },
      },
    })
);

export const VoucherCardContent = customStyled(Box)(({ theme: { space, radii, colors } }) => ({
  padding: space[3],
  paddingBottom: space[2],
  backgroundColor: colors.white,
  borderBottomRightRadius: radii[4],
  borderBottomLeftRadius: radii[4],
}));

export const ApplyButton = customStyled(Button)(
  ({ theme: { fontWeights, fontSizes, radii, colors }, disabled }) => ({
    borderRadius: radii[1],
    ...(!disabled
      ? {
          backgroundColor: COLORS.PERSIAN_GREEN,
        }
      : {}),
    color: colors.white,
    fontSize: fontSizes[1],
    fontWeight: fontWeights[7],
    height: 'auto',
    padding: '8px 16px',
    border: 'none',
  })
);

export const BottomMessage = customStyled(Flex)<{
  variant: IVoucherCardVariant;
  isApplied?: boolean;
}>(
  ({ theme: { fontSizes, radii, space }, isApplied }) => ({
    borderRadius: `0 0 ${radii[3]}px ${radii[3]}px`,
    fontSize: fontSizes[1],
    padding: isApplied ? '12px 16px' : '4px 16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space[2],
  }),
  (props: any) =>
    variant({
      variants: {
        success: {
          background: props.theme.colors.lightGreen,
        },
        error: {
          background: props.theme.colors.peach,
        },
        disabled: {
          background: props.theme.colors.GRAY_100,
        },
      },
    })
);

export const CodeApplied = customStyled(Flex)(({ theme: { fontSizes, fontWeights, space } }) => ({
  fontSize: fontSizes[1],
  fontWeight: fontWeights[7],
  textTransform: 'capitalize',
  alignItems: 'center',
  gap: space[2],
  color: COLORS.PERSIAN_GREEN,
}));

export const Description = customStyled(Box)(({ theme: { fontSizes } }) => ({
  fontSize: fontSizes[1],
}));

export const Badge = customStyled(Box)<{ bg: string; color: string }>(
  ({ theme: { fontSizes, radii, space }, bg, color }) => ({
    borderRadius: radii[2],
    backgroundColor: bg,
    fontSize: fontSizes[0],
    fontWeight: 'bold',
    padding: `2px ${space[2]}px`,
    whiteSpace: 'nowrap',
    color,
    lineHeight: `${space[3]}px`,
    textAlign: 'center',
  }),
  () =>
    variant({
      variants: {
        [VoucherBadgeVariant.TopFlat]: {
          marginTop: '1px',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
        [VoucherBadgeVariant.BottomFlat]: {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      },
    })
);

export const ImagesWrapper = customStyled(Flex)(({ theme: { space } }) => ({
  alignItems: 'center',
  boxSizing: 'content-box',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: '4px 8px 4px 0',
  minWidth: '52px',
  paddingRight: space[2],
}));

export const Title = customStyled(Box)(({ theme: { fontSizes, fontWeights, space } }) => ({
  fontSize: fontSizes[2],
  fontWeight: fontWeights[7],
  marginBottom: space[1],
}));

export const TnCLink = customStyled(Button)(({ theme: { fontSizes, fontWeights, space } }) => ({
  fontSize: fontSizes[1],
  fontWeight: fontWeights[7],
  height: '16px',
  display: 'flex',
  gap: space[2],
  alignItems: 'center',
}));

export const TnCRow = customStyled(Box)(({ theme: { fontSizes, space } }) => ({
  display: 'list-item',
  fontSize: fontSizes[0],
  listStylePosition: 'inside',
  paddingLeft: space[2],
}));

export const VoucherCode = customStyled(Box)(({ theme: { fontSizes, fontWeights, space } }) => ({
  border: '1px dashed',
  display: 'inline-block',
  fontSize: fontSizes[2],
  fontWeight: fontWeights[6],
  marginBottom: space[2],
  padding: space[2],
}));

export const VoucherRow = customStyled(Flex)(({ theme: { space } }) => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: space[1],
}));
